module.exports = __webpack_public_path__ + "static/media/Nguyen_Xuan_Anh.908d786c.jpeg";